import type { Snapshot } from '../snapshots/api';

/** Допустимые виды исследования (выбираются из списка). */
export const STUDY_TYPES = ['3D', '2D'] as const;
export type StudyType = (typeof STUDY_TYPES)[number];

export interface Examination {
  id: string;
  patientId: string;
  examinedAt: string; // YYYY-MM-DD
  modality: string;
  note: string;
  fileCount: number;
  createdAt: string;
}

export interface ExaminationInput {
  patientId: string;
  examinedAt: string;
  modality?: string;
  note?: string;
}

export interface ExaminationFile extends Snapshot {
  downloadUrl: string;
  viewUrl: string;
  /** JPEG-дериваты от воркера; отсутствуют, пока файл не обработан. */
  thumbnailUrl?: string;
  previewUrl?: string;
}

export interface ExaminationDetail {
  examination: Examination;
  /** ФИО пациента — обследование открывают в отрыве от карточки пациента, поэтому дублируем. */
  patientName: string;
  /** E-mail из карточки пациента — подставляется в форму «Отправить на почту». */
  patientEmail: string;
  files: ExaminationFile[];
  /** Может ли текущий пользователь отправить обследование по e-mail (ведущий врач / админ). */
  canShare: boolean;
}

/** Ссылка на скачивание обследования, отправленная по e-mail человеку без аккаунта. */
export interface ShareLink {
  id: string;
  email: string;
  createdByName: string;
  createdAt: string;
  expiresAt: string;
  revokedAt: string | null;
  downloadCount: number;
  lastDownloadedAt: string | null;
  status: 'active' | 'expired' | 'revoked';
}

export interface ExaminationComment {
  id: string;
  authorId: string;
  authorName: string;
  body: string;
  createdAt: string;
  updatedAt: string;
}

export type ArchiveJobStatus =
  | 'pending'
  | 'uploaded'
  | 'extracting'
  | 'succeeded'
  | 'failed';

export interface ArchiveJob {
  id: string;
  status: ArchiveJobStatus;
  fileCount: number;
  extracted: number;
  lastError: string;
}

export interface Paged<T> {
  items: T[];
  total: number;
  limit: number;
  offset: number;
}
